import { defineMessages } from "react-intl";

export default defineMessages({
  desktopTitle: {
    id: "Appointment.AppointmentSummaryDesktop.title",
    defaultMessage: "Your Appointment",
  },
});
